import {call, put, takeLatest, fork, all} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as CouponService from './../services/couponService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {
    setCoupon as setCouponAction,
} from './../actions/couponAction';
import { parseProductPromotion } from '../utils/coupon';
import { message } from 'antd';

function* getCoupon() {
    yield takeLatest(Types.GET_COUPON, Func.sagaWrapper(function* (action) {
        const dataProducts = parseProductPromotion(action.couponCode, action.typeProduct, action.idProduct, action.quantity)
        const result = yield call(CouponService.getCoupon, dataProducts);
        if(!result.isValid) {
            message.error(i18n.t('validation.getCouponFail'))
            return
        }
        result.couponCode = action.couponCode
        yield put(setCouponAction(result));
        successHandleCoupon(action, action.couponCode)
    }, errorHandleCoupon(Types.COUPON_FAIL)))
}

function successHandleCoupon(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.successCoupon')}`,
        description: `${i18n.t('item.order.couponCode')} "${value}"`
    })
}

function errorHandleCoupon(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'order');
}

export function* couponSaga() {
    yield all([
        fork(getCoupon),
    ])
}
